import { InformationIcon } from '@amazd/common/icons';
import { FormControl, SxProps, Tooltip } from '@mui/material';
import { colors } from 'styles/theme';

import useStyles from './styles';

type Props = {
  label?: string;
  subLabel?: string;
  hint?: string;
  tooltipInfo?: string;
  className?: string;
  children: React.ReactNode;
  sx?: SxProps;
};

const Control = ({ label, subLabel, hint, tooltipInfo, className, children, sx }: Props) => {
  const classes = useStyles();

  return (
    <FormControl sx={sx} className={`${classes.root} ${className}`}>
      {(label || subLabel) && (
        <div className={classes.header}>
          {label && (
            <span className={classes.label}>
              {label}{' '}
              {tooltipInfo && (
                <Tooltip title={tooltipInfo} placement={'top'} arrow>
                  <div className={classes.tooltipInfo}>
                    <InformationIcon color={colors.grey50} style={{ fontSize: 20 }} />
                  </div>
                </Tooltip>
              )}
            </span>
          )}
          {subLabel && <div className={classes.subLabel}>{subLabel}</div>}
        </div>
      )}
      {children}
      {hint && <span className={classes.hint}>{hint}</span>}
    </FormControl>
  );
};

export default Control;
